module.exports = __webpack_public_path__ + "img/mos-main-swiper1.b11eebff.png";